/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientDiagnosesViewModel } from './PatientDiagnosesViewModel'; 

export function getDiagnosesOptions(certificationPeriodId: string, onSuccess?: (result: PatientDiagnosesViewModel) => void) {
	return queryOptions({
		queryKey: ['diagnoses', certificationPeriodId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/diagnoses/queries/getdiagnoses/' + certificationPeriodId;
			const resp = await axios.get<PatientDiagnosesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(certificationPeriodId)
	});
}